/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_PalletsInputs */

const en_inbound_field_pallets = /** @type {(inputs: Inbound_Field_PalletsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pallets`)
};

/**
* | output |
* | --- |
* | "Pallets" |
*
* @param {Inbound_Field_PalletsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_pallets = /** @type {((inputs?: Inbound_Field_PalletsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_PalletsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_pallets(inputs)
});